<div class="flex-container" data-cy="save-as-dialog">
  <mat-form-field color="accent">
    <mat-label>{{ 'FILENAME' | translate }}</mat-label>
    <input [(ngModel)]="filename" cdkFocusInitial matInput>
  </mat-form-field>
  <button (click)="save()" mat-button>
    {{ 'OK' | translate }}
  </button>
</div>
